const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    className: "banned_svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.976562 2.976562 C 6.855469 -0.898438 13.144531 -0.898438 17.023438 2.976562 C 20.898438 6.855469 20.898438 13.144531 17.023438 17.023438 C 13.144531 20.898438 6.855469 20.898438 2.976562 17.023438 C -0.898438 13.144531 -0.898438 6.855469 2.976562 2.976562 M 5.238281 16.234375 C 8.359375 18.621094 12.769531 18.328125 15.546875 15.546875 C 18.328125 12.769531 18.621094 8.359375 16.234375 5.238281 Z M 14.761719 3.765625 C 11.640625 1.378906 7.230469 1.671875 4.453125 4.453125 C 1.671875 7.230469 1.378906 11.640625 3.765625 14.761719 Z M 14.761719 3.765625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanned);
export default __webpack_public_path__ + "static/media/banned.544c4d1a79a104ac3aa9f4fb7e6d07ce.svg";
export { ForwardRef as ReactComponent };